import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme/ThemeContext';
import TokenService from '../../lib/tokenService';
import { getUserBalance, getMyInfo } from '../../lib/api';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faClock, faIndianRupeeSign, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const [dateTime, setDateTime] = useState(new Date());
  const [ipAddress, setIpAddress] = useState('');
  const [balance, setBalance] = useState(null);
  const [myInfo, setMyInfo] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    // Fetch IP (client-side)
    axios
      .get('https://api.ipify.org?format=json')
      .then((res) => setIpAddress(res.data?.ip || ''))
      .catch(() => {});

    // Fetch balance
    getUserBalance()
      .then((data) => setBalance(data?.balance ?? null))
      .catch((e) => setError(e?.message || 'Failed to load balance'));

    // Fetch user info
    getMyInfo()
      .then((data) => setMyInfo(data?.userInfo?.name || ''))
      .catch((e) => setError(e?.message || 'Failed to load profile'));

    return () => clearInterval(timer);
  }, []);

  const formattedDate = useMemo(() => dateTime.toLocaleDateString(), [dateTime]);
  const formattedTime = useMemo(
    () => dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    [dateTime]
  );

  const onLogout = (e) => {
    e.preventDefault();
    TokenService.clearToken();
    navigate('/login', { replace: true });
  };

  return (
    <nav className={`navbar ${theme}`} style={{ position: 'fixed', zIndex: 999, top: 0, left: 0, right: 0 }}>
      <div className="navbar-left">
        <h1 className="navbar-title" style={{ marginBottom: 0 }}>{myInfo || 'Messaging Alerts'}</h1>
      </div>
      <div className="navbar-menu">
        <button className="icon-btn" title={ipAddress ? `IP: ${ipAddress}` : 'IP: —'} aria-label="IP address">
          <FontAwesomeIcon icon={faGlobe} />
          <span className="icon-label">IP: {ipAddress || '—'}</span>
        </button>
        <button className="icon-btn" title={`Date: ${formattedDate} Time: ${formattedTime}`} aria-label="Date and time">
          <FontAwesomeIcon icon={faClock} />
          <span className="icon-label">{formattedDate} {formattedTime}</span>
        </button>
        <button className="icon-btn" title={error ? 'Balance: —' : `Balance: ₹${balance ?? '—'}`} aria-label="Balance">
          <FontAwesomeIcon icon={faIndianRupeeSign} />
          <span className="icon-label">₹{balance ?? '—'}</span>
        </button>
        <button className="navbar-logout" onClick={onLogout} aria-label="Logout">
          <FontAwesomeIcon icon={faRightFromBracket} />
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
